import { Heading, Image, Text, VStack } from '@chakra-ui/react';
//@ts-ignore
import EmptyImage from './assets/empty.png';
import { pxToRem } from './utils';

export const MobileRedirect = () => {
  return (
    <VStack
      height={'100vh'}
      pb={pxToRem(100)}
      textAlign={'center'}
      alignItems="center"
      justifyContent="center"
    >
      <Image height={pxToRem(350)} width={pxToRem(350)} src={EmptyImage} alt="Empty" />
      <Heading as="h1" mt="4" fontSize="x-large">
        Incompatible device size!
      </Heading>
      <Text>
        Please use a desktop device <br /> for a better experience.{' '}
      </Text>
    </VStack>
  );
};
